import type { Events } from './events';

interface AnalyticsUser {
  anonymousId: () => string;
}

declare global {
  interface Window {
    analytics: {
      track: (...args: unknown[]) => Promise<void>;
      instance: { user: () => AnalyticsUser } | null;
    };
  }
}

const loggedAbTestNames = new Set<string>();

const logEvent = <E extends keyof Events>(event: E, params: Events[E]) => {
  let testName: string | undefined;
  if (event === 'ab_test_variant_assigned') {
    const testName = (params as Events['ab_test_variant_assigned']).testName;
    if (loggedAbTestNames.has(testName)) return;
  }
  if (!window.analytics?.track) {
    console.error(
      'could not find global window.analytics.track, event logging is skipped',
    );
    console.log(event, params);
    return;
  }
  void window.analytics.track(`vo_demo_${event}`, params);
  if (testName) {
    loggedAbTestNames.add(testName);
  }
};

export { logEvent };
